// Função para converter string em slug amigável para URL
export function createUrlSlug(text: string): string {
  return text
    .normalize('NFD') // Normaliza caracteres acentuados
    .replace(/[\u0300-\u036f]/g, '') // Remove acentos
    .toLowerCase() // Converte para minúsculas
    .replace(/[^\w\s-]/g, '') // Remove caracteres especiais
    .replace(/\s+/g, '-') // Substitui espaços por hífens
    .replace(/--+/g, '-') // Substitui múltiplos hífens por um único hífen
    .trim(); // Remove espaços extras no início/fim
}

// Função para extrair ID de um slug composto
export function extractIdFromSlug(slug: string): string | null {
  if (!slug) {
    return null;
  }
  
  // Verificar se o slug já é um UUID completo
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  if (uuidRegex.test(slug)) {
    return slug;
  }
  
  // Verificar se o slug contém um UUID completo
  const uuidInString = slug.match(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i);
  if (uuidInString) {
    return uuidInString[0];
  }
  
  // Método anterior: o ID está na última parte do slug após o último hífen
  const parts = slug.split('-');
  if (parts.length > 0) {
    const lastPart = parts[parts.length - 1];
    return lastPart;
  }
  
  // Se não encontrou um ID válido
  return slug;
}